import type { BadgeColor } from '@enamelai/design-system'

export enum CategoryType {
  IMPLANT_SERVICES = 'Implant Services',
  ORAL_AND_MAXILLOFACIAL_SURGERY = 'Oral and Maxillofacial Surgery',
  DENTAL_CARE = 'Dental care',
  ORTHODONTICS = 'Orthodontics',
  ADJUNCTIVE_SERVICES = 'Adjunctive Services',
  PREVENTIVE = 'Preventive',
  DIAGNOSTIC = 'Diagnostic',
  PERIODONTICS = 'Periodontics',
  PROSTHODONTICS_REMOVABLE = 'Prosthodontics, Removable',
  PROSTHODONTICS_FIXED = 'Prosthodontics, Fixed',
  RESTORATIVE = 'Restorative',
  ENDODONTICS = 'Endodontics',
  UNCATEGORIZED = 'Uncategorized',
}

export const categoryTypes = Object.values(CategoryType)

export const CATEGORY_BADGE_COLORS: Record<CategoryType, BadgeColor> = {
  [CategoryType.IMPLANT_SERVICES]: 'orange',
  [CategoryType.ORAL_AND_MAXILLOFACIAL_SURGERY]: 'yellow',
  [CategoryType.DENTAL_CARE]: 'vivid-green',
  [CategoryType.ORTHODONTICS]: 'purple',
  [CategoryType.ADJUNCTIVE_SERVICES]: 'indigo',
  [CategoryType.PREVENTIVE]: 'teal',
  [CategoryType.DIAGNOSTIC]: 'blue',
  [CategoryType.PERIODONTICS]: 'pale-green',
  [CategoryType.PROSTHODONTICS_REMOVABLE]: 'cyan',
  [CategoryType.PROSTHODONTICS_FIXED]: 'pink',
  [CategoryType.RESTORATIVE]: 'lime-green',
  [CategoryType.ENDODONTICS]: 'red',
  [CategoryType.UNCATEGORIZED]: 'gray',
}

export const PROVIDER_BADGE_STYLE = {
  backgroundColor: 'var(--blue-100)',
  color: 'var(--blue-600)',
}
